<div class="informative informative-salers">
    <div class="po-row po-lg-4 po-md-12 po-sm-12 po-mt-2 po-m-0 po-p-0">
      <po-widget id="meta" class="po-lg-12 po-md-12 po-sm-12 po-m-0" p-title="Meta de vendas" style="position: relative; cursor: pointer;">
        <span class="po-icon po-icon-exclamation icon-info-meta" (click)="openInfo()"></span>
        <div class="po-lg-6 po-md-6 po-sm-6" style="font-size: 10px">
          <div class="po-row" style="padding: 3px 0px 3px 0px"><span class="po-pl-1 po-pr-1 po-color-01" style="border-radius: 100px; color: white !important; width: 60px; text-align: center;">Empresa</span> <span class="po-ml-1">{{metaBoardEmpresa}}</span></div>
          <div class="po-row" style="padding: 3px 0px 3px 0px"><span class="po-pl-1 po-pr-1 po-color-01" style="border-radius: 100px; color: white !important; width: 60px; text-align: center;">Meta</span> <span class="po-ml-1">{{metaBoardMeta}}</span></div>
          <div class="po-row" style="padding: 3px 0px 3px 0px"><span class="po-pl-1 po-pr-1 po-color-01" style="border-radius: 100px; color: white !important; width: 60px; text-align: center;">Período</span> <span class="po-ml-1">{{metaBoardPeriodoInicio}} à {{metaBoardPeriodoFim}}</span></div>
        </div>
        <div class="po-lg-6 po-md-6 po-sm-6">
          <div class="po-font-subtitle po-text-center info-meta-value">
            <span>R${{metaSaleSplit}}</span>
          </div>
          <div class="po-lg-12 po-md-12 po-sm-12 po-pl-0 po-pr-0 info-meta-grafico">
            <fusioncharts
              [width]="width"
              [height]="height"
              [type]="type"
              [dataFormat]="dataFormat"
              [dataSource]="dataSource"
            >
            </fusioncharts>
          </div>
        </div>
      </po-widget>
      <div id="metaInfo" style="display: none !important; width: 100%;">
        <po-widget class="po-lg-12 po-md-12 po-sm-12 po-m-0" p-title="Para visualização da meta é necessário" style="position: relative;">
          <span class="po-icon po-icon-close info-meta-close" (click)="closeInfo()"></span>
          <ul class="po-pl-2 po-pb-1" style="font-size: 11px; background-color: white;">
              <li>Filtrar apenas uma empresa onde o vendedor está lotado</li>
              <li>Ter registro de meta no COMFM027 para o vendedor para a empresa do filtro</li>
              <li>Para mais informações visite nossa documentação <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=880448700" target="_blank">clicando aqui</a></li>
          </ul>
        </po-widget>
      </div>
    </div>
    <div class="p-row po-lg-8 po-md-12 po-sm-12">
      <po-widget class="po-lg-4 po-md-6 po-sm-6 po-mt-2"
        p-title="Total de vendas">
        <div class="po-font-subtitle po-text-center">
          <span class="po-font-text-small">R$</span>
          <span>{{totalSplit}}</span>
        </div>
      </po-widget>
      <po-widget class="po-lg-4 po-md-6 po-sm-6 po-mt-2" p-title="Ticket médio">
        <div class="po-font-subtitle po-text-center">
          <span class="po-font-text-small">R$</span>
          <span>{{tmSplit}}</span>
        </div>
      </po-widget>
      <po-widget class="po-lg-4 po-md-6 po-sm-6 po-mt-2" p-title="PMPV">
        <div class="po-font-subtitle po-text-center">
          <span class="po-font-text-small">R$</span>
          <span>{{pmpvSplit}}</span>
        </div>
      </po-widget>
      <po-widget class="po-lg-4 po-md-6 po-sm-6 po-mt-2" p-title="PA">
        <div class="po-font-subtitle po-text-center">
          <span>{{pa}}</span>
        </div>
      </po-widget>
      <po-widget class="po-lg-4 po-md-6 po-sm-6 po-mt-2" p-title="PU">
        <div class="po-font-subtitle po-text-center">
          <span>{{pu}}%</span>
        </div>
      </po-widget>
      <po-widget class="po-lg-4 po-md-6 po-sm-6 po-mt-2" p-title="Desconto médio">
        <div class="po-font-subtitle po-text-center">
          <span>{{averageDiscount}}%</span>
        </div>
      </po-widget>
    </div>
  </div>